import React, { useEffect, useState } from "react";
import { ReactComponent as IconNoticeClose } from "./icon/icon_notice_close.svg";
import { ReactComponent as IconNoticeDivide } from "./icon/icon_notice_divide.svg";
import { ReactComponent as IconNoticeFintech } from "./icon/icon_notice_fintech.svg";
import { ReactComponent as IconNoticeGroup } from "./icon/icon_notice_group.svg";
import { getAntiFraudNotice } from "@/firebase";
import styles from "./index.module.scss";

const Notice = () => {
  const [data, setData] = useState({ title: "", content: "" });
  const [toggle, setToggle] = useState(false);
  const localFirstIn = window.localStorage.getItem("firstIn");

  useEffect(() => {
    const fetchNoticeData = async () => {
      try {
        const noticeData = await getAntiFraudNotice();
        const isvalidNoticeData = noticeData.isValid;
        if (isvalidNoticeData && noticeData.title && noticeData.content)
          setData(noticeData);
      } catch (error) {
        console.log("Error fetching notice data:", error);
      }
    };

    fetchNoticeData();
  }, []);

  return (
    <>
      {!toggle && !localFirstIn && data.title && data.content ? (
        <div className={styles.notice}>
          <div className={styles.layout}>
            <IconNoticeClose
              className={styles.close}
              onClick={() => {
                setToggle(true);
                window.localStorage.setItem("firstIn", true);
              }}
            />
            <div className={styles.noticeBanner}>公告</div>
            <div className={styles.noticeTitle}>{data.title}</div>
            <div className={styles.noticeContent}>{data.content}</div>
            <div className={styles.imgGroup}>
              <IconNoticeGroup />
              <IconNoticeDivide />
              <IconNoticeFintech />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Notice;
